import { render } from "./BranchSelector.vue?vue&type=template&id=60f1c418&scoped=true"
import script from "./BranchSelector.vue?vue&type=script&lang=js"
export * from "./BranchSelector.vue?vue&type=script&lang=js"

import "./BranchSelector.vue?vue&type=style&index=0&id=60f1c418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f1c418"]])

export default __exports__